import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { debounce } from "lodash";
export default {
  name: "TagList",
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tagList: [],
      otherTags: [],
      keyword: "",
      loading: true,
      emptyTag: ""
    };
  },
  created: function created() {},
  methods: {
    setType: function setType(tag) {
      return this.value.some(function (item) {
        return item === tag;
      });
    },
    setTagList: function setTagList(list) {
      this.tagList = _toConsumableArray(new Set(list));
    },
    selectTag: function selectTag(tag) {
      var arr = _toConsumableArray(this.value);
      var index = arr.indexOf(tag);
      index > -1 ? arr.splice(index, 1) : arr.push(tag);
      this.$emit("input", arr);
    },
    showSearch: function showSearch() {
      var _this$otherTags;
      if (this.loading && !((_this$otherTags = this.otherTags) !== null && _this$otherTags !== void 0 && _this$otherTags.length)) {
        this.search();
      }
    },
    chooseTag: function chooseTag(tag) {
      var index = this.tagList.indexOf(tag);
      if (index === -1) {
        this.tagList.push(tag);
      } else {
        this.$message({
          message: "已存在该标签！",
          type: "warning"
        });
      }
    },
    //创建标签
    createTag: function createTag() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var index, res, name;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              index = _this.tagList.indexOf(_this.emptyTag);
              if (!(index === -1)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return _this.$api.addCommunityTag({
                name: _this.emptyTag,
                type: 0
              });
            case 1:
              res = _context.v;
              name = res.data.name;
              name && _this.tagList.push(name);
              _this.search();
              _context.n = 3;
              break;
            case 2:
              _this.$message({
                message: "已存在该标签！",
                type: "warning"
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    search: debounce(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var res, _this$otherTags2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            this.loading = true;
            _context2.n = 1;
            return this.$api.getCommunityTagList({
              name: this.keyword,
              page: 1,
              limit: 20
            });
          case 1:
            res = _context2.v;
            if (res.code === 200) {
              this.otherTags = res.data.list || [];
              if (!((_this$otherTags2 = this.otherTags) !== null && _this$otherTags2 !== void 0 && _this$otherTags2.length) && this.keyword) {
                this.emptyTag = this.keyword;
              }
            }
            this.loading = false;
          case 2:
            return _context2.a(2);
        }
      }, _callee2, this);
    })), 300)
  }
};